// extracted by mini-css-extract-plugin
export default {"SlateMention":"SlateMention_SlateMention__nQuyd","SlateMentionSelected":"SlateMention_SlateMentionSelected__3z-yq"};